import React from 'react';
import { Section, Container } from '../common';
import { TrendingUp, Clock, ShieldCheck, Users, BarChart3, Zap } from 'lucide-react';

const benefits = [
  {
    title: 'Aumente seu Faturamento',
    description: 'Venda mais sem pagar taxas abusivas para marketplaces e tenha o dinheiro direto na sua conta.',
    icon: TrendingUp,
    color: 'text-success'
  },
  {
    title: 'Economize Tempo Real',
    description: 'Automatize o recebimento de pedidos e libere sua equipe para focar no que realmente importa: a comida.',
    icon: Clock,
    color: 'text-primary-custom'
  },
  {
    title: 'Redução Zero de Erros',
    description: 'Pedidos integrados e organizados eliminam falhas de comunicação entre salão, balcão e cozinha.',
    icon: ShieldCheck,
    color: 'text-primary-custom'
  },
  {
    title: 'Fidelização Automática',
    description: 'Transforme clientes casuais em fãs recorrentes com ferramentas de marketing e cashback integradas.',
    icon: Users,
    color: 'text-primary-custom'
  },
  {
    title: 'Controle Total (360°)',
    description: 'Acompanhe vendas, estoque e desempenho da equipe em tempo real, de onde você estiver.',
    icon: BarChart3,
    color: 'text-primary-custom'
  },
  {
    title: 'Agilidade no Delivery',
    description: 'Roteirização inteligente e gestão de entregadores para garantir que o pedido chegue quente ao cliente.',
    icon: Zap,
    color: 'text-primary-custom'
  }
];

const Benefits = () => {
  return (
    <Section id="beneficios" className="bg-white overflow-hidden">
      <Container>
        <div className="text-center mb-5 max-width-700 mx-auto">
          <span className="badge bg-primary text-dark mb-2 px-3 py-2 rounded-pill fw-bold">RESULTADOS REAIS</span>
          <h2 className="fw-bold mb-3 display-5">Mais lucro e organização para o seu negócio</h2>
          <p className="text-secondary fs-5">
            Não somos apenas um sistema de pedidos. Somos o parceiro que ajuda seu restaurante a crescer de forma sustentável e profissional.
          </p>
        </div>

        <div className="row align-items-center g-5">
          <div className="col-lg-5 order-2 order-lg-1" data-aos="fade-right">
            <div className="row g-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="col-12">
                  <div className="d-flex align-items-start p-3 bg-light rounded-4 transition-hover border border-light h-100">
                    <div className={`p-3 rounded-3 bg-white shadow-sm me-4 ${benefit.color}`}>
                      <benefit.icon size={28} />
                    </div>
                    <div>
                      <h4 className="fw-bold h6 mb-1">{benefit.title}</h4>
                      <p className="text-muted small mb-0">{benefit.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="col-lg-7 order-1 order-lg-2" data-aos="fade-left">
            <div className="position-relative">
              {/* Elementos Decorativos */}
              <div className="position-absolute top-0 start-0 translate-middle bg-primary-light rounded-circle" style={{ width: '300px', height: '300px', opacity: 0.4, zIndex: 0, filter: 'blur(50px)' }}></div>
              
              <div className="card border-0 shadow-2xl rounded-5 overflow-hidden position-relative" style={{ zIndex: 1 }}>
                <img 
                  src="https://images.unsplash.com/photo-1552566626-52f8b828add9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" 
                  alt="Restaurante moderno e organizado" 
                  className="img-fluid w-100" 
                  style={{ minHeight: '500px', objectFit: 'cover' }}
                />
                <div className="position-absolute bottom-0 start-0 w-100 p-4 bg-dark bg-opacity-75 backdrop-blur text-white">
                  <div className="d-flex align-items-center">
                    <div className="bg-primary p-2 rounded-circle me-3">
                      <TrendingUp size={24} className="text-dark" />
                    </div>
                    <div>
                      <p className="mb-0 fw-bold">Média de +35% no faturamento</p>
                      <p className="mb-0 small opacity-75">Relatado por clientes após 3 meses de uso</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card Flutuante de Estatística */}
              <div className="position-absolute top-10 end-0 translate-middle-y bg-white p-4 rounded-4 shadow-lg d-none d-md-block" style={{ zIndex: 2, marginRight: '-30px', maxWidth: '200px' }}>
                <div className="text-center">
                  <h3 className="fw-800 text-primary-custom mb-0">10min</h3>
                  <p className="small text-muted mb-0">Tempo médio de configuração</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default Benefits;
